import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "linealignment"
    }}>{`LineAlignment`}</h1>
    <p>{`Line justification options.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LEFT_OR_TOP_LINE_ALIGN`}</strong>{` = 1818324084`}</p>
      <p parentName="blockquote">{`Left aligns horizontal text or top aligns vertical text.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CENTER_LINE_ALIGN`}</strong>{` = 1818321774`}</p>
      <p parentName="blockquote">{`Center aligns the text.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`RIGHT_OR_BOTTOM_LINE_ALIGN`}</strong>{` = 1818325602`}</p>
      <p parentName="blockquote">{`Right aligns horizontal text or bottom aligns vertical text.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LEFT_OR_TOP_LINE_JUSTIFY`}</strong>{` = 1819047018`}</p>
      <p parentName="blockquote">{`Justifies horizontal text on both the right and left and left aligns the last line or justifies vertical text on both the top and bottom and top aligns the last line.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CENTER_LINE_JUSTIFY`}</strong>{` = 1818455658`}</p>
      <p parentName="blockquote">{`Justifies horizontal text on both the right and left and center aligns the last line or justifies vertical text on both the top and bottom and center aligns the last line.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`RIGHT_OR_BOTTOM_LINE_JUSTIFY`}</strong>{` = 1819435626`}</p>
      <p parentName="blockquote">{`Justifies horizontal text on both the right and left and right aligns the last line or justifies vertical text on both the top and bottom and bottom aligns the last line.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FULL_LINE_JUSTIFY`}</strong>{` = 1818651754`}</p>
      <p parentName="blockquote">{`Justifies horizontal text on both the right and left or justifies vertical text on both the top and bottom and gives all lines a uniform length.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      